<template>
  <div>
    <SysBotao
      class="font-16 py-0 px-3 ml-3 font-weight-regular"
      :class="{'cursor-no-drop': desabilitar}"
      radius="8"
      color-texto="white"
      background="#d54f4f"
      @click="abrirDialogConfirmacao"
    >
      Finalizar carrinho
    </SysBotao>

    <v-dialog
      v-model="dialog_confirmacao"
      width="400"
      content-class="bra-20"
      transition="dialog-top-transition"
      persistent
    >
      <v-card>
        <v-card-title>
          <span>Confirmação</span>
          <v-spacer />
          <v-btn icon title="cancelar" @click="dialog_confirmacao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="py-5 font-14">
            Deseja realmente finalizar o carrinho de compras?
          </p>
        </v-card-text>

        <v-card-actions class="mt-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="finalizarPedidoCompra()"
          >
            sim, confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysBotao from "../../../utils/botoes/SysBotao";
import {finalizarPedidoCompra} from "../../../../api/compraPorDepartamentos/PedidoCompraTipo";
import {logout} from "../../../../helpers";

export default {
  name: "FinalizarCarrinho",
  components: {
    SysBotao
  },
  props: {
    desabilitar: Boolean,
    pedido: Object
  },
  data: () => ({
    dialog_confirmacao: false,
  }),
  methods: {
    abrirDialogConfirmacao() {
      if (!this.desabilitar) {
        this.dialog_confirmacao = !this.dialog_confirmacao;
      }
    },
    finalizarPedidoCompra() {
      this.$store.dispatch('loading/addRequisicao',
        finalizarPedidoCompra(this.pedido.id).then(this.finalizacaoComSucesso).catch(logout)
      );
    },
    finalizacaoComSucesso() {
      this.dialog_confirmacao = false;
      setTimeout(() => (this.$emit('pedido-compra-finalizado', {})), 500);
    }
  }
}
</script>

<style scoped>

</style>
